import Swiper, { Autoplay, Controller, EffectCreative, Navigation, Pagination } from "swiper";

document.addEventListener('DOMContentLoaded', () => {
  const aboutSliders = document.querySelectorAll('.about-block__slider')

  if (aboutSliders) {
    aboutSliders.forEach(slider => {
      const prevEl = slider.querySelector('.about-block__navigation .slider-navigation__button--prev')
      const nextEl = slider.querySelector('.about-block__navigation .slider-navigation__button--next')
      const swiper = new Swiper(slider, {
        modules: [Navigation, EffectCreative, Autoplay, Controller, Pagination],
        effect: "creative",
        speed: 1000,
        parallax: true,
        loop: true,
        allowTouchMove: false,
        spaceBetween: 2,
        creativeEffect: {
          prev: {
            translate: ["-20%", 0, -1],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        },
        pagination: {
          el: '.about-block__pagination-list',
          clickable: true,
          bulletClass: 'about-block__pagination pagination__item',
          bulletActiveClass: 'pagination__item--active'
        },
        navigation: {
          prevEl,
          nextEl
        },
        breakpoints: {
          999: {
            allowTouchMove: false
          },
          0: {
            allowTouchMove: true
          }
        }
      })
      let paginations = slider.querySelectorAll('.pagination__item')

      const createSlider = () => {
        let throttle = false
        let timeout
        const startTimeout = () => {
          clearTimeout(timeout)
          if (throttle) {
            timeout = setTimeout(() => {
              throttle = false
              swiper.slideNext()
            }, 30000)
          } else {
            timeout = setTimeout(() => {
              swiper.slideNext()
            }, 10000)
          }
        }

        let animate = false
        window.addEventListener('scroll', () => {
          if (animate) return;
          if (window.scrollY > slider.offsetTop + slider.clientHeight) return
          if (window.scrollY >= slider.offsetTop - slider.clientHeight) {
            animate = true
            paginations[0].classList.remove('pagination__item--active')
            setTimeout(() => {
              paginations[0].classList.add('pagination__item--active')
            })
            startTimeout()
          }
        })

        swiper.on('touchMove', () => throttle = true)

        swiper.on('slideChange', startTimeout)
        paginations.forEach(pagination => {
          pagination.addEventListener('click', () => throttle = true)
        })
        prevEl.addEventListener('click', () => throttle = true)
        nextEl.addEventListener('click', () => throttle = true)
      }

      let timeoutPag

      const checkPagination = () => {
        if (!paginations.length) {
          clearTimeout(timeoutPag)
          timeoutPag = setTimeout(() => {
            paginations = slider.querySelectorAll('.about-block__pagination')
            checkPagination()
          }, 200)
          return
        }
        createSlider()
      }
      checkPagination()

    })
  }

  const teamSlider = document.querySelector('.about-team__slider')

  if (teamSlider) {
    const prevEl = document.querySelector('.about-team__button--prev')
    const nextEl = document.querySelector('.about-team__button--next')

    const swiper = new Swiper(teamSlider, {
      modules: [Navigation, Autoplay, Controller, Pagination],
      speed: 1000,
      parallax: true,
      loop: true,
      allowTouchMove: false,
      spaceBetween: 20,
      slidesPerView: 'auto',
      pagination: {
        el: '.about-team__pagination-list',
        clickable: true,
        bulletClass: 'about-block__pagination pagination__item',
        bulletActiveClass: 'pagination__item--active'
      },
      breakpoints: {
        999: {
          allowTouchMove: false,
          slidesPerGroup: 3,
        },
        779: {
          slidesPerView: 'auto'
        },
        0: {
          slidesPerGroup: 1,
          slidesPerView: 1,
          allowTouchMove: true
        }
      }
    })

    let paginations = teamSlider.querySelectorAll('.about-block__pagination')

    let timeout


    const createSlider = () => {
      const paginationInner = teamSlider.querySelector('.about-team__pagination-inner')

      paginations[0]?.classList.remove('about-block__pagination--active')


      let throttle = false
      let timeout
      const startTimeout = () => {
        clearTimeout(timeout)
        if (throttle) {
          timeout = setTimeout(() => {
            throttle = false
            swiper.slideNext()
          }, 30000)
        } else {
          timeout = setTimeout(() => {
            swiper.slideNext()
          }, 10000)
        }
      }

      let animate = false
      window.addEventListener('scroll', () => {
        if (animate) return;
        if (window.scrollY >= teamSlider.offsetTop - teamSlider.clientHeight) {
          animate = true
          paginations[0].classList.remove('pagination__item--active')
          paginations[0].classList.add('pagination__item--active')
          startTimeout()

        }
      })

      swiper.on('touchMove', () => throttle = true)

      paginations.forEach(pagination => {
        pagination.addEventListener('click', () => throttle = true)
      })
      prevEl.addEventListener('click', () => {
        throttle = true
        swiper.slidePrev()
      })
      nextEl.addEventListener('click', () => {
        throttle = true
        swiper.slideNext()
      })
      swiper.on('slideChange', () => {
        if (window.innerWidth < 1000) {
          paginationInner.scrollTo({
            left: paginations[swiper.realIndex].offsetLeft,
            behavior: 'smooth'
          })
        }
        startTimeout()
      })
    }


    const setTimeOutPag = () => {
      if (!paginations.length) {
        timeout = setTimeout(() => {
          paginations = teamSlider.querySelectorAll('.about-block__pagination')
          setTimeOutPag()
        }, 200)
        return
      }
      createSlider()
    }
    setTimeOutPag()
  }
})